import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import VisualBanner from './components/VisualBanner';
import CategorySection from './components/CategorySection';
import CTASection from './components/CTASection';
import StatsSection from './components/StatsSection';
import ArticlesSection from './components/ArticlesSection';
import BottomCTA from './components/BottomCTA';
import { homeSchema, organizationSchema } from '@/mocks/schema';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <VisualBanner />
        <CategorySection />
        <CTASection />
        <StatsSection />
        <ArticlesSection />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}